/**
 * @generated SignedSource<<28abe30d5248dc79a39830eb3292b51a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AnnouncementCard_announcement$data = {
  readonly id: string;
  readonly links: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly item: {
        readonly content?: {
          readonly fileName?: string;
          readonly mimeType?: string;
          readonly url?: URIString;
        };
        readonly id?: string;
        readonly " $fragmentSpreads": FragmentRefs<"ItemCardSmall" | "ItemCard_item">;
      } | null;
    } | null> | null;
  };
  readonly message: UnknownJSON | null;
  readonly space: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"SpaceContextCard_space">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"AnnouncementMetadata_announcement">;
  readonly " $fragmentType": "AnnouncementCard_announcement";
};
export type AnnouncementCard_announcement$key = {
  readonly " $data"?: AnnouncementCard_announcement$data;
  readonly " $fragmentSpreads": FragmentRefs<"AnnouncementCard_announcement">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnnouncementCard_announcement",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SpaceContextCard_space"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AnnouncementLinkConnection",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AnnouncementLink",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "item",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ItemCard_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ItemCardSmall"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/)
                  ],
                  "type": "FolderItem",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "content",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "fileName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "mimeType",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "url",
                              "storageKey": null
                            }
                          ],
                          "type": "File",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "AnnouncementAttachment",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnnouncementMetadata_announcement"
    }
  ],
  "type": "Announcement",
  "abstractKey": null
};
})();

(node as any).hash = "9e96e0bddf2f7894b7b28c0f33b3fc49";

export default node;
